export const POSTTAG_RESPONSES = {
  SCHEDULE_PROCESSED: "Schedule processed successfully.",
};
